import { render, staticRenderFns } from "./ConstruireParcours.vue?vue&type=template&id=56c42c2c"
import script from "./ConstruireParcours.vue?vue&type=script&lang=js"
export * from "./ConstruireParcours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports